import { render, staticRenderFns } from "./BundleItemsSelect.vue?vue&type=template&id=1c270916&scoped=true&"
import script from "./BundleItemsSelect.vue?vue&type=script&lang=js&"
export * from "./BundleItemsSelect.vue?vue&type=script&lang=js&"
import style0 from "./BundleItemsSelect.vue?vue&type=style&index=0&id=1c270916&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c270916",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VChip } from 'vuetify/lib/components/VChip';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VAutocomplete,VChip,VListItem,VListItemAction,VListItemContent,VListItemTitle,VSimpleCheckbox})
